import { useEffect, useState } from "react";
import { Box, Button, Container } from "@mui/material";
import { Add } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import campimg from "../../assets/promotion.png";
import cashipluslogo from "../../assets/CashiPluslogo.png";
import { callPostApi } from "../API/ApiCallFunction";
import GradientLoader from "../CommanComponents/GradientLoader";
import TrendingFlatIcon from "@mui/icons-material/TrendingFlat";

function DashboardReport() {
  const user = JSON.parse(sessionStorage.getItem("user") || "{}");
  const navigate = useNavigate();
  // let maxxdate = "";
  const [startdate, setStartDate] = useState(
    sessionStorage.getItem("startdate")
  );
  const [enddate, setEndDate] = useState(sessionStorage.getItem("enddate"));

  const [loading, setLoading] = useState(false);
  const [datar, setDatar] = useState({
    total_generate_point: 0,
    total_redeem_point: 0,
    total_new_customer: 0,
    total_retain_customer: 0,
    total_sale_amount: 0,
    total_customer: 0,
  });
  const cashi_plus_flag = user.store_info.cashi_plus_flag;
  //  const cashi_plus_flag = "1";
  const formatDate = (date) => {
    const yyyy = date.getFullYear();
    const mm = String(date.getMonth() + 1).padStart(2, "0");
    const dd = String(date.getDate()).padStart(2, "0");
    // maxxdate = `${yyyy}-${mm}-${dd}`;
    return `${yyyy}-${mm}-${dd}`;
    // return `${dd}-${mm}-${yyyy}`;
  };
  useEffect(() => {
    const today = new Date();
    const yesterday = new Date(today);
    yesterday.setDate(today.getDate() - 1); // subtract one day :contentReference[oaicite:0]{index=0}
    if (!sessionStorage.getItem("startdate")) {
      setEndDate(formatDate(today));
      setStartDate(formatDate(yesterday));
      sessionStorage.setItem("enddate", formatDate(today));
      sessionStorage.setItem("startdate", formatDate(yesterday));
    }

    // maxxdate = formatDate(today);
  }, []);
  const dashbaordApi = async (start,end) => {

      const startdatee = start || sessionStorage.getItem("startdate");
  const enddatee = end || sessionStorage.getItem("enddate");


    setLoading(true);
    const storeid = user.store_info.store_id;
    const payload = {
      mod: "CASHI_LOYALTY_DASHBOARD",
      data_arr: { store_id: storeid, startDate: startdatee, endDate: enddatee },
    };
    const apiResult = await callPostApi("cashi-dashboard", payload);
    if (apiResult.status === "200" && apiResult.data) {
      const item = apiResult.data;

      setDatar({
        total_generate_point: item.total_generate_point || 0,
        total_redeem_point: item.total_redeem_point || 0,
        total_new_customer: item.total_new_customer || 0,
        total_retain_customer: item.total_retain_customer || 0,
        total_sale_amount: item.total_sale_amount || 0,
        total_customer: item.total_customer,
      });
      setLoading(false);
    } else {
      setLoading(false);
    }
  };

  const gotosalereport = () => {
    navigate("/dashboardsalereport", {
      state: {
        startdate: startdate,
        enddate: enddate,
      },
    });
  };
  const gotocustomerreport = () => {
    navigate("/customerlistdashbaord", {
      state: {
        startdate: startdate,
        enddate: enddate,
      },
    });
  };
  const handlesearch = () => {
    dashbaordApi();
  };
  const clearfilter = () => {
    const today = new Date();
    const yesterday = new Date(today);
      yesterday.setDate(today.getDate() - 1);
    sessionStorage.setItem("startdate", "" + formatDate(yesterday));
    sessionStorage.setItem("enddate", "" + formatDate(today));
    setStartDate(formatDate(yesterday));
    setEndDate(formatDate(today));

      dashbaordApi(formatDate(yesterday),formatDate(today));


  };
  // Handler for end date
  const handleEndDateChange = (e) => {
    sessionStorage.setItem("enddate", e.target.value);
    setEndDate(e.target.value);
  };

  const handleStartDateChange = (e) => {
    sessionStorage.setItem("startdate", e.target.value);
    setStartDate(e.target.value);
  };
  const cards = [
    {
      id: "1",
      title: "Points Rewarded",
      value: datar.total_generate_point,
      color: "blue",
    },
    {
      id: "2",
      title: "Points Exchanged",
      value: datar.total_redeem_point,
      color: "yellow",
    },
    {
      id: "3",
      title: "New Users",
      value: datar.total_new_customer,
      color: "pink",
    },
    {
      id: "4",
      title: "Users Retained",
      value: datar.total_retain_customer,
      color: "darkblue",
    },
    {
      id: "5",
      title: "Total Sale",
      value: "₹" + datar.total_sale_amount,
      color: "orange",
    },
    {
      id: "6",
      title: "Total Customers",
      value: datar.total_customer,
      color: "green",
    },
  ];
  useEffect(() => {
    dashbaordApi();
  }, []);

  return (
    <Box>
      <Box>
        <Container>
          <Box display="flex" justifyContent="space-between" flexWrap={"wrap"}>
            <Box display="flex" alignItems="center">
              <Button
                variant="contained"
                sx={{
                  ml: 1,
                  m: 1,
                  background: "linear-gradient(195deg, #66BB6A, #43A047)",
                }}
                onClick={() => navigate("/dashboard")}
              >
                HOME{" "}
              </Button>
              <Button
                variant="contained"
                onClick={() => navigate("/createcoupon")}
              >
                {" "}
                <Add /> Create Coupon{" "}
              </Button>
              <Button
                variant="contained"
                sx={{
                  ml: 1,
                  background: "linear-gradient(195deg, #66BB6A, #43A047)",
                }}
                onClick={() => navigate("/couponlist")}
              >
                {" "}
                Coupon List{" "}
              </Button>
              <Button
                sx={{
                  backgroundColor: "#eee",
                  ml: 1,
                  boxShadow:
                    "rgba(0, 0, 0, 0.02) 0px 1px 3px 0px, rgba(27, 31, 35, 0.15) 0px 0px 0px 1px",
                }}
                onClick={() => navigate("/campaignList")}
              >
                <img
                  src={campimg}
                  alt="campaign"
                  style={{ height: "30px", width: "auto" }}
                />{" "}
              </Button>
            </Box>
            {cashi_plus_flag === "1" && (
              <Button onClick={() => navigate("/dashboardPlus")}>
                <img
                  src={cashipluslogo}
                  alt="cashi plus"
                  style={{ height: "60px", width: "auto" }}
                />
              </Button>
            )}
          </Box>
          <div className="dashboard">
            <div className="date‐range text-center m-3">
              <input
                type="date"
                value={startdate}
                onChange={handleStartDateChange}
              />{" "}
              {" to "}
              <input
                type="date"
                value={enddate}
                onChange={handleEndDateChange}
              />
              <Button
                variant="contained"
                sx={{
                  ml: 1,
                  background: "linear-gradient(195deg, #66BB6A, #43A047)",
                }}
                onClick={() => handlesearch()}
              >
                {" "}
                Apply{" "}
              </Button>
              <Button
                variant="contained"
                sx={{
                  ml: 1,
                  background: "linear-gradient(195deg, #d07f15ff, #d07f15ff)",
                }}
                onClick={() => clearfilter()}
              >
                {" "}
                Clear{" "}
              </Button>
            </div>
            <div className="container">
              <div className="row">
                {cards.map((c, index) =>
                  c.id === "5" ? (
                    <div key={index} className="col-12 col-sm-6 col-md-6 mb-4">
                      <div
                        className={`card card-${c.color} col-12`}
                        style={{ cursor: "pointer" }}
                      >
                        <div
                          className="card-body"
                          onClick={() => gotosalereport()}
                        >
                          <div className="value">
                            <TrendingFlatIcon />
                          </div>
                          <div className="value">{c.value}</div>
                          <div className="title">{c.title}</div>
                        </div>
                      </div>
                    </div>
                  ) : c.id === "6" ? (
                    <div key={index} className="col-12 col-sm-6 col-md-6 mb-4">
                      <div
                        className={`card card-${c.color} col-12`}
                        style={{ cursor: "pointer" }}
                      >
                        <div
                          className="card-body"
                          onClick={() => gotocustomerreport()}
                        >
                          <div className="value">
                            <TrendingFlatIcon />
                          </div>
                          <div className="value">{c.value}</div>
                          <div className="title">{c.title}</div>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div key={index} className="col-12 col-sm-6 col-md-6 mb-4">
                      <div className={`card card-${c.color} col-12`}>
                        <div className="card-body">
                          <div className="value">{c.value}</div>
                          <div className="title">{c.title}</div>
                        </div>
                      </div>
                    </div>
                  )
                )}
              </div>
            </div>
          </div>
        </Container>
        {loading && <GradientLoader text="Loading" />}
      </Box>

      <style>
        {`
    .promotion:hover {
      background-color: #ffffff;
    }
  `}
      </style>
    </Box>
  );
}

export default DashboardReport;
